export const SeparatorQcFieldName = 'separatorQcFieldComponent';
